import React, { Component } from 'react';

import $ from 'jquery';

class Home extends Component {

  constructor(props) {
    super(props);
  }
  
  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;
    t.pageLoad();

    this.changePositioning();
    this.props.updateLang();
    window.addEventListener('resize', this.changePositioning);

    $('#mobile-footer-info-panel').fadeIn()
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();
  }

  changePositioning() {
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
  }
  
  render() {
  	return <div className='mobile-main-page-container' style={{
    
    }}>
      <div className='mobile-main-page' style={{

      }}>
        <img className='mobile-main-page-bg' src={'/mobile/page/' + this.props.lang + '/home.png'} style={{
          'minWidth': '100%',
          'width': '100%'
        }}/>
        
      </div>
  	</div>
  }

};

export default Home;



// WEBPACK FOOTER //
// ./src/mobile/page/Home.js